module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTI4IiBoZWlnaHQ9IjEyOCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMCAwaDU0Ljg1N3Y1NC44NTdIMFYwem0wIDczLjE0M2g1NC44NTdWMTI4SDBWNzMuMTQzem03My4xNDMgMEgxMjhWMTI4SDczLjE0M1Y3My4xNDN6bTI3LjQyOC0xOC4yODZDMTE1LjcyIDU0Ljg1NyAxMjggNDIuNTc3IDEyOCAyNy40MyAxMjggMTIuMjggMTE1LjcyIDAgMTAwLjU3MSAwIDg1LjQyMyAwIDczLjE0MyAxMi4yOCA3My4xNDMgMjcuNDI5YzAgMTUuMTQ4IDEyLjI4IDI3LjQyOCAyNy40MjggMjcuNDI4eiIvPjwvc3ZnPg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/component.svg
// module id = 507
// module chunks = 75